import React, { useState, useContext, useEffect } from "react";
import { ContentContext } from "context/Content";
import DropdownMenu from "components/Menus/DropdownMenu";
import AuditLog from "./History/AuditLog";
import VersionCompare from "./History/VersionCompare";
import { modal } from "components/HeadlessModal";

export default function HistoryButton(props) {
    const { state } = useContext(ContentContext);
    const [myContent, setMyContent] = useState({});

    const showLog = () => {
        modal.wide({
            title: "Audit Log",
            children: <AuditLog content={myContent} />,
        });
    };

    const showVersions = () => {
        modal.wide({
            title: "Version Compare",
            children: <VersionCompare content={myContent} />,
        });
    };

    useEffect(() => {
        setMyContent(state.content);
    }, [state.content]);

    return (
        <DropdownMenu
            label="History"
            variant="secondary"
            disabled={!state.content.uuid}
            menuItems={[
                <button
                    className="w-full text-left"
                    type="button"
                    onClick={showVersions}
                >
                    Version History
                </button>,
                <button
                    className="w-full text-left"
                    type="button"
                    onClick={showLog}
                >
                    Audit Log
                </button>,
            ]}
        />
    );
}
